import { useRequestGetUsers } from '@/hooks/httpRequest';
import { Button, DialogFooter } from '@/components/ui';
import { ISearchUserData } from '@/lib/interface';
import { useFormContext } from 'react-hook-form';
import { UserAccountStatusEnum } from '@/enums';
import { broadcastService } from '@/services';
import { useState } from 'react';
import { TFormData } from '.';

interface IState {
  isLoading: boolean;
}

type TProps = {
  callback: (user: ISearchUserData) => Promise<void>;
  submitButtonTitle: string;
};

const VARIABLES = {
  initState: {
    isLoading: false
  } as IState
};

const FormSearchUserFooter = ({ callback, submitButtonTitle }: TProps) => {

  const { handleSubmit, setValue, formState: { isValid, isSubmitting } } = useFormContext<TFormData>();
  const [state, setState] = useState<IState>(VARIABLES.initState);
  const { fetchData } = useRequestGetUsers(undefined, false);

  const handleOnClickBtnCancel = () =>
    broadcastService.modal.hide();

  const handleOnClickBtnSave = () =>
    handleSubmit(
      async data => {
        try {
          setState(l => ({ ...l, isLoading: true }));
          // Call submit mehtod
          const user =
            await
              fetchData({
                email: data.email,
                accountStatus: [UserAccountStatusEnum.ACTIVE]
              })
                .then(data => data?.data?.[0])
                .catch(error => { throw new Error(error?.internalMessage); });
          // Check user found
          if (!user) {
            throw new Error('Utilisateur introuvable ou inactif.');
          }
          // Close modal
          broadcastService.modal.hide();
          // call callback
          callback(user);
        } catch (error) {
          setValue('errorMessage', (error as Error)?.message);
        } finally {
          setState(l => ({ ...l, isLoading: false }));
        }
      }
    )();

  return (
    <DialogFooter>
      <div className='w-full flex justify-between'>
        <Button
          onClick={handleOnClickBtnCancel}
          disabled={isSubmitting || state.isLoading}
          variant='secondary'
          type='button'
          size={'sm'}>
          Annuler
        </Button>
        <Button
          onClick={handleOnClickBtnSave}
          disabled={!isValid || isSubmitting || state.isLoading}
          type='button'
          size={'sm'}>
          {submitButtonTitle}
        </Button>
      </div>
    </DialogFooter>
  );

};

export default FormSearchUserFooter;
